import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';

import { ProformViewStates } from '../../dtos/proforms.dto';
import { ObsvSessionSubmissionResponse } from '../../types/responses/coaching-log.responses';
import { ProFormsSubmissionAPIResponse } from '../../types/responses/proforms.responses';
import { ModalComponent } from '../modals/modal/modal.component';

@Component({
  selector: 'app-coaching-log-prev-submissions-modal',
  standalone: false,
  templateUrl: './coaching-log-prev-submissions-modal.component.html',
  styleUrl: './coaching-log-prev-submissions-modal.component.scss',
})
export class CoachingLogPrevSubmissionsModalComponent
  implements OnChanges, OnInit
{
  @ViewChild('modal') modal: ModalComponent;

  @Input() sessionSubmissionsData: ObsvSessionSubmissionResponse[];

  @Input() currentSubmissionIdx: number;

  viewStates = ProformViewStates;

  isLoading: boolean;

  currentSubmission: ObsvSessionSubmissionResponse | undefined;

  ngOnInit(): void {
    if (this.sessionSubmissionsData && this.sessionSubmissionsData.length > 0) {
      if (this.currentSubmissionIdx) {
        this.showSubmissionDetails(
          this.sessionSubmissionsData[
            this.currentSubmissionIdx
          ] as ObsvSessionSubmissionResponse
        );
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['currentSubmissionIdx'] && this.sessionSubmissionsData) {
      this.showSubmissionDetails(
        this.sessionSubmissionsData[
          this.currentSubmissionIdx
        ] as ObsvSessionSubmissionResponse
      );
    }
  }

  goToSubmission(direction: 'next' | 'previous') {
    this.isLoading = true;
    if (direction === 'next') {
      this.currentSubmissionIdx += 1;
    } else {
      this.currentSubmissionIdx -= 1;
    }
    const submissionToDisplay = this.currentSubmissionIdx % 10;

    this.showSubmissionDetails(
      this.sessionSubmissionsData[submissionToDisplay]
    );
  }

  showSubmissionDetails(submission: ObsvSessionSubmissionResponse) {
    this.currentSubmission = submission;
    this.isLoading = false;
  }

  // eslint-disable-next-line class-methods-use-this
  openSession(submission: ProFormsSubmissionAPIResponse) {
    window.open(
      `/observation/log/${submission.context_table_id}/info`,
      '_blank'
    );
  }
}
